import { render, staticRenderFns } from "./AppPager.vue?vue&type=template&id=bdebddb0&scoped=true"
import script from "./AppPager.vue?vue&type=script&lang=js"
export * from "./AppPager.vue?vue&type=script&lang=js"
import style0 from "./AppPager.vue?vue&type=style&index=0&id=bdebddb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdebddb0",
  null
  
)

export default component.exports